export class InstagramSuccesConnectModalControllerDpr {
    static $inject = ['close', 'openConfiguration'];
    constructor(close, openConfiguration) {
        this.close = close;
        this.openConfiguration = openConfiguration;
        this.closeModal = () => {
            this.close();
        };
    }
    onConfirm() {
        this.close();
    }
    onConfigurationChannel() {
        this.openConfiguration();
        this.close();
    }
}
InstagramSuccesConnectModalControllerDpr.$inject = ['close', 'openConfiguration'];
